<script>
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Multiselect from "vue-multiselect";
export default {
  name: "FeeModal",
  props: {
    modalTitle: String,
    accounts: Array,
  },
  components: {
    MaskedInput,
    Multiselect
  },
  data(){
    return {
        form: {
            id: 0,
            name: null,
            shortName: null,
            defaultAmount: '',
            accountId: null,
            visible: true,
            active: true,
            account: null
        },
        submitted: false,
        currencyMask: createNumberMask({
            prefix: "",
            allowDecimal: true,
        }),
    }
  },
  validations: {
    form: {
      name: { required },
      accountId: { required }
    },
  },
  methods: {
    updateData(data){
      this.submitted = false;
      this.form = cloneDeep(data)
    },
    submitForm(){
      this.submitted = true;
      this.$v.form.$touch();
      if(this.$v.form.$invalid) return;
      this.$emit('submit', this.form);
    },
    customLabel({ uacs, accountName }) {
      return `${uacs} - ${accountName}`;
    },
    selectOpt(opt){
        this.form.accountId = opt.id;
    }
  }
};
</script>
<template>
    <b-modal
        id="fee-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form  @submit.prevent="submitForm">
            <div class="mb-3">
                <label for="feeName">Fee Name</label>
                <input 
                    autocomplete="off"
                    id="name"
                    type="text" 
                    class="form-control" 
                    v-model="form.name" 
                    :class="{'is-invalid': submitted && $v.form.name.$error}"

                />
                <div 
                    v-if="submitted && $v.form.name.$error"
                    class="invalid-feedback"
                >name
                    <span v-if="!$v.form.name.required">Fee name is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="shortName">Description</label>
                <input 
                    autocomplete="off"
                    id="shortName"
                    type="text" 
                    class="form-control" 
                    v-model="form.shortName"
                />
            </div>
            <div class="mb-3">
                <label for="account">Account</label>
                <multiselect
                    v-model="form.account"
                    track-by="id"
                    modelValue="id"
                    value="id"
                    label="accountName"
                    placeholder="Select accounts"
                    :custom-label="customLabel"
                    :options="accounts"
                    :searchable="true"
                    :multiple="false"
                    :close-on-select="true"
                    :show-labels="false"
                    :allow-empty="false"
                    @select="selectOpt"
                    :class="{
                        'is-invalid': submitted && $v.form.accountId.$error,
                    }"
                >
                </multiselect>
                <div v-if="submitted && $v.form.accountId.$error" class="invalid-feedback">
                    <span v-if="!$v.form.accountId.required">Account is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="defaultAmt">Default Amount</label>
                <masked-input
                    autocomplete="off"
                    type="text"
                    v-model="form.defaultAmount"
                    placeholder="Enter Amount..."
                    class="form-control text-right"
                    :mask="currencyMask"
                >
                </masked-input>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary"><i class="bx bx-save"></i>{{ form.id != 0 ? "Update" : "Save" }}</button>
                <button type="button" class="btn btn-link" @click="$bvModal.hide('fee-modal')">Close</button>
            </div>
        </form>
    </b-modal>
</template>